import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { Fragment, memo, useCallback, useEffect, useRef, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import AccordionRegistrationIdentityCardForm from './form';
import {
  AccordionIdentityCardVM,
  RegistationIdCardFormVM,
} from 'front-office/view-models/registration-id-card';
import { DateTime } from 'luxon';

interface AccordionRegistrationIdentityCardProps {
  disabled?: boolean;
}

const AccordionRegistrationIdentityCardComponent = ({
  disabled,
}: AccordionRegistrationIdentityCardProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<RegistationIdCardFormVM>();

  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    ref.current?.scrollIntoView();
  }, []);

  const onFieldIdentityCardChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('identityCard', {
        ...formContext.values.identityCard,
        [key]: value,
      });
    },
    [formContext.values.identityCard, formContext.setFieldValue]
  );

  const onFieldsIdentityCardChange = useCallback(
    (values) => {
      formContext.setFieldValue('identityCard', {
        ...formContext.values.identityCard,
        ...values,
      });
    },
    [formContext.values.identityCard, formContext.setFieldValue]
  );

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
        ref={ref}
      >
        <AccordionSummary
          aria-controls="panel-identity-card-content"
          id="panel-identity-card-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>{"Registrazione Carta d'Identità"}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <AccordionRegistrationIdentityCardForm
            disabled={disabled}
            values={formContext.values.identityCard}
            onChangeValues={onFieldsIdentityCardChange}
            birthday={
              formContext.values.generality?.dataNascita
                ? DateTime.fromISO(formContext.values.generality?.dataNascita)
                : null
            }
            errors={formContext.errors.identityCard as FormikErrors<AccordionIdentityCardVM>}
            touched={formContext.touched.identityCard as FormikTouched<AccordionIdentityCardVM>}
            onChange={onFieldIdentityCardChange}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionRegistrationIdentityCardComponent.displayName =
  'Accordion registration identity card component';

const AccordionRegistrationIdentityCard = memo(AccordionRegistrationIdentityCardComponent);

export default AccordionRegistrationIdentityCard;
